import { Manifest } from "@cayo/shared/types/manifest";

export const APP_IDS = {
  GUARDIAN: "cayo_guardian",
  ADMINISTRATOR: "cayo_administrator",
} as const;

export type AppId = (typeof APP_IDS)[keyof typeof APP_IDS];

export const getAppId = (manifest?: Manifest | null): AppId | null => {
  const value = manifest?.short_name;

  if (!value) {
    return null;
  }

  if (value === APP_IDS.GUARDIAN || value === APP_IDS.ADMINISTRATOR) {
    return value;
  }

  return null;
};
